/* ============================================================================
   LED-maszk termekoldal: feny-valaszto + hullamhossz-szinezo.

   A modok NEM a kodban ulnek: a szekcio Liquidje ir ki egy JSON-t
   (data-lm-modes-data), es ez a fajl abbol epitkezik. Igy a theme editorban
   felvett vagy atirt mod azonnal latszik, kod nelkul.

   Ujrafuttathato: a theme editor `shopify:section:load` esemenye ujra meghivja,
   kulonben szerkesztes utan halott vezerlo maradna.
   ============================================================================ */
(function () {
  "use strict";
  /* 2026-10-05: a hero ES a light szekcio is betolti ezt a fajlt (mindkettonek kell, ha a masik nincs a
     lapon), es a ket <script> ketszer futtatta: minden scroll-listener duplan dolgozott. Egyszer fut. */
  if (window.__lmBoot) return;
  window.__lmBoot = 1;
  var NS = "http://www.w3.org/2000/svg";
  var LO = 380, HI = 900, W = 560;
  var NIR = { nm: 850 };

  function x(nm) { return (nm - LO) / (HI - LO) * W; }
  function el(t, a) { var n = document.createElementNS(NS, t); for (var k in a) n.setAttribute(k, a[k]); return n; }
  /* 2026-10-22: a feliratok forditasa a window.dsT-bol (snippets/ds-i18n-js), magyar tartalekkal */
  function lt(k, hu) { var v = (window.dsT || {})[k]; return v || hu; }
  function num(v) { var n = parseFloat(String(v || "").replace(",", ".")); return isNaN(n) ? null : n; }

  function parseBand(s) {
    if (!s) return null;
    var p = String(s).split(/[^\d.,]+/).filter(Boolean).map(num).filter(function (v) { return v !== null; });
    return p.length === 2 ? p : null;
  }

  /* ------------------------------------------------------------------ *
   * 1. HULLAMHOSSZ- ES SZIN-SZOVEG SZINEZESE
   *
   * Marci kerese: ahol hullamhossz vagy szin van emlitve, a szoveg legyen
   * OLYAN SZINU. A szoveg a theme editorbol jon, tehat nem lehet kezzel
   * span-ekbe csomagolni: ez a fuggveny futas idoben csinalja.
   *
   * ⚠️ Ket dologra kell figyelni:
   *   - az "infravoros" TARTALMAZZA a "voros"-t, ezert eloBB kell illeszteni,
   *   - a "feher" nincs a listan: feher lapon lathatatlan lenne.
   * A szin a `--c` valtozoba megy, a CSS vilagos modban sotetiti (kulonben a
   * sarga es a cian olvashatatlan lenne papiron).
   * ------------------------------------------------------------------ */
  var HUE = {
    piros: "#FF3B22", voros: "#FF3B22", kek: "#4657FF", zold: "#2FE06A",
    sarga: "#FFB302", lila: "#C24BFF", cian: "#22D3E0", nir: "#C0392B"
  };
  function nmColor(nm) {
    if (nm < 450) return HUE.lila;
    if (nm < 496) return HUE.kek;
    if (nm < 571) return HUE.zold;
    if (nm < 591) return HUE.sarga;
    if (nm < 621) return "#FF8A00";
    if (nm < 751) return HUE.piros;
    return HUE.nir;
  }
  var HU = "a-zA-ZáéíóöőúüűÁÉÍÓÖŐÚÜŰ";
  var RX = new RegExp(
    "(\\d{3,4})\\s?nm\\b" +
    "|(?:közeli\\s+)?infra\\s?vörös[" + HU + "]{0,5}" +
    "|vörös[" + HU + "]{0,5}|piros[" + HU + "]{0,5}|kék[" + HU + "]{0,5}" +
    "|zöld[" + HU + "]{0,5}|sárga[" + HU + "]{0,5}|lila[" + HU + "]{0,5}|cián[" + HU + "]{0,5}",
    "gi");

  function hueFor(match) {
    var m = match.toLowerCase();
    if (/^\d/.test(m)) return nmColor(parseInt(m, 10));
    if (m.indexOf("infra") >= 0) return HUE.nir;
    if (m.indexOf("vörös") === 0 || m.indexOf("piros") === 0) return HUE.piros;
    if (m.indexOf("kék") === 0) return HUE.kek;
    if (m.indexOf("zöld") === 0) return HUE.zold;
    if (m.indexOf("sárga") === 0) return HUE.sarga;
    if (m.indexOf("lila") === 0) return HUE.lila;
    if (m.indexOf("cián") === 0) return HUE.cian;
    return null;
  }

  /* v17b: a bizonyitek-fokonyv es a tabla-cellak NEM kapnak szot-szinezest: az allapot-szinu
     szovegben a masik szinu szo konfetti (Marci: "undorito"). A fejlecek es a proza igen. */
  var SKIP = ".lm-modes, .lm-read, .lm-nm, .lm-dip__tag, .lm-evl, .lm-endp, .lm-cmp, .lm-specm__badge, .lm-specm__pdf";
  function colorize(root) {
    var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, {
      acceptNode: function (n) {
        if (!n.nodeValue || n.nodeValue.length < 3) return NodeFilter.FILTER_REJECT;
        var p = n.parentElement;
        if (!p) return NodeFilter.FILTER_REJECT;
        /* SVG-text-be nem lehet span-t tenni, a gomb-feliratokon meg mar ott a szin-negyzet */
        if (p.closest("script, style, svg, " + SKIP)) return NodeFilter.FILTER_REJECT;
        RX.lastIndex = 0;
        return RX.test(n.nodeValue) ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_REJECT;
      }
    });
    var todo = [], n;
    while ((n = walker.nextNode())) todo.push(n);
    todo.forEach(function (node) {
      var txt = node.nodeValue, frag = document.createDocumentFragment(), last = 0, m;
      RX.lastIndex = 0;
      while ((m = RX.exec(txt))) {
        var c = hueFor(m[0]);
        if (!c) continue;
        if (m.index > last) frag.appendChild(document.createTextNode(txt.slice(last, m.index)));
        var s = document.createElement("span");
        s.className = "lm-nm";
        s.style.setProperty("--c", c);
        s.textContent = m[0];
        frag.appendChild(s);
        last = m.index + m[0].length;
      }
      if (!frag.childNodes.length) return;
      if (last < txt.length) frag.appendChild(document.createTextNode(txt.slice(last)));
      node.parentNode.replaceChild(frag, node);
    });
  }

  /* ------------------------------------------------------------------ *
   * 2. FENY-VALASZTO
   * ------------------------------------------------------------------ */
  function init(root) {
    var pick = root.querySelector("[data-lm-pick]");
    var data = root.querySelector("[data-lm-modes-data]");
    if (!pick || !data) return;

    var MODES;
    try { MODES = JSON.parse(data.textContent); } catch (e) { return; }
    if (!MODES || !MODES.length) return;

    MODES.forEach(function (m) {
      m.nmv = num(m.nm);
      m.bandv = parseBand(m.band);
      m.mixv = m.mix ? String(m.mix).split(/[\s,]+/).filter(Boolean) : null;
    });

    var box = pick.querySelector("[data-lm-modes]");
    /* 2026-10-18: a gyarto mert spektruma (.lm-specm__fig) ugyanugy modonkent valt, mint a stage fotoi */
    var stageImgs = pick.querySelectorAll(".lm-stage img, .lm-specm__fig img");
    var roName = pick.querySelector("[data-lm-name]");
    var roNm = pick.querySelector("[data-lm-nm]");
    var roNote = pick.querySelector("[data-lm-note]");
    var roEv = pick.querySelector("[data-lm-ev]");
    var roEvWrap = pick.querySelector("[data-lm-evwrap]");
    /* 2026-08-26: a valaszto alatti "miert pont ez a hullamhossz" panel (a szekcioban, a pick-en kivul) */
    var whyEl = root.querySelector("[data-lm-why]");
    var whyName = root.querySelector("[data-lm-why-name]");
    var whyNm = root.querySelector("[data-lm-why-nm]");
    var axg = pick.querySelector("[data-lm-axg]");
    var ticks = pick.querySelector("[data-lm-ticks]");
    var waves = pick.querySelector("[data-lm-waves]");
    var wmark = pick.querySelector("[data-lm-wmark]");

    /* tengely: fix skala + a mindig futo 850 nm. 2026-10-18: a tengely es a hullam-abra kikerult a lapbol
       (helyettuk a gyarto mert spektruma), ezert minden rajzolas null-vedett. */
    var marks = {};
    if (axg && ticks) {
    ticks.textContent = "";
    [400, 500, 600, 700, 800, 900].forEach(function (v) {
      ticks.appendChild(el("line", { x1: x(v), y1: 60, x2: x(v), y2: 67, class: "ax-tick" }));
      var t = el("text", { x: x(v), y: 79, "text-anchor": "middle", class: "lab" });
      t.textContent = v; ticks.appendChild(t);
    });

    axg.textContent = "";
    axg.appendChild(el("line", { x1: x(NIR.nm), y1: 16, x2: x(NIR.nm), y2: 60, stroke: HUE.nir, "stroke-dasharray": "3 3" }));
    var nl = el("text", { x: x(NIR.nm), y: 11, "text-anchor": "middle", class: "lab" });
    nl.textContent = "850 · " + lt("lm_always", "MINDIG"); axg.appendChild(nl);

    MODES.forEach(function (m) {
      var g = el("g", { class: "peak", opacity: "0" });
      var pts = [];
      if (m.nmv !== null) pts = [m.nmv];
      else if (m.mixv) {
        pts = m.mixv.map(function (k) {
          var o = MODES.filter(function (z) { return z.k === k; })[0];
          if (!o) return null;
          return o.nmv !== null ? o.nmv : (o.bandv ? (o.bandv[0] + o.bandv[1]) / 2 : null);
        }).filter(function (v) { return v !== null; });
      }
      if (m.bandv) {
        g.appendChild(el("rect", { x: x(m.bandv[0]), y: 34, width: x(m.bandv[1]) - x(m.bandv[0]), height: 26, fill: "url(#lmhatch)", opacity: ".55" }));
        g.appendChild(el("rect", { x: x(m.bandv[0]), y: 34, width: x(m.bandv[1]) - x(m.bandv[0]), height: 26, fill: "none", class: "pk-line", "stroke-width": "1.2" }));
        var bt = el("text", { x: (x(m.bandv[0]) + x(m.bandv[1])) / 2, y: 28, "text-anchor": "middle", class: "lab" });
        bt.textContent = lt("lm_band", "SAV"); g.appendChild(bt);
      }
      pts.forEach(function (p) {
        g.appendChild(el("line", { x1: x(p), y1: 24, x2: x(p), y2: 70, class: "pk-line", "stroke-width": "1.6" }));
        g.appendChild(el("circle", { cx: x(p), cy: 24, r: 3.2, class: "pk-dot" }));
      });
      if (m.nmv !== null) {
        var t = el("text", { x: x(m.nmv), y: 16, "text-anchor": "middle", class: "lab pk-lab" });
        t.textContent = m.nmv + " NM"; g.appendChild(t);
      } else if (pts.length) {
        var t2 = el("text", { x: (x(pts[0]) + x(pts[pts.length - 1])) / 2, y: 16, "text-anchor": "middle", class: "lab pk-lab" });
        t2.textContent = lt("lm_mixed", "KEVERT"); g.appendChild(t2);
      }
      marks[m.k] = g; axg.appendChild(g);
    });
    }

    /* hullam-abra: a periodus ARANYOS a hullamhosszal */
    function sine(nm, amp, y0) {
      var per = nm * 0.1, d = "M -" + per + " " + y0, cx = -per;
      while (cx < 620 + per) {
        d += " q " + (per / 4) + " " + (-amp) + " " + (per / 2) + " 0 q " + (per / 4) + " " + amp + " " + (per / 2) + " 0";
        cx += per;
      }
      return { d: d, per: per };
    }
    function drawWave(m) {
      if (!waves || !wmark) return;
      waves.textContent = ""; wmark.textContent = "";
      var parts;
      if (m.mixv) {
        parts = m.mixv.map(function (k) {
          var o = MODES.filter(function (z) { return z.k === k; })[0];
          if (!o) return null;
          /* 2026-08-25: nm es sav nelkuli osszetevo (zold, cian) KIMARAD, nincs kitalalt 550 */
          if (o.nmv === null && !o.bandv) return null;
          return { nm: o.nmv !== null ? o.nmv : (o.bandv[0] + o.bandv[1]) / 2, css: o.css };
        }).filter(Boolean);
      } else if (m.nmv !== null || m.bandv) {
        parts = [{ nm: m.nmv !== null ? m.nmv : (m.bandv[0] + m.bandv[1]) / 2, css: m.css }];
      } else {
        parts = [];
      }
      /* 2026-08-25: ha a modhoz nem irunk csucsot (zold: egyik forras sem ad; cian: a regi adatlap ad
         szamot, a friss nem, es a friss a regi mas ertekeit felulirta), NEM rajzolunk kitalalt hullamot */
      if (!parts.length) {
        var t0 = el("text", { x: 150, y: 60, class: "lab" });
        /* semleges: a pontos okot a mod jegyzete mondja, itt nem allitunk semmit a gyartorol */
        t0.textContent = lt("lm_no_peak", "ERRE A MODRA NEM IRUNK CSUCS-HULLAMHOSSZAT");
        wmark.appendChild(t0);
        return;
      }
      var amp = parts.length > 1 ? 18 : 26, y0 = 49;
      parts.forEach(function (p, i) {
        var w = sine(p.nm, amp, y0);
        var g = el("g", { class: "wrun" });
        g.style.setProperty("--p", w.per + "px");
        g.style.animationDuration = (w.per / 26) + "s";
        g.appendChild(el("path", { d: w.d, class: "wpath", stroke: p.css, opacity: i ? ".72" : "1" }));
        waves.appendChild(g);
      });
      var per = parts[0].nm * 0.1, x1 = 150, x2 = 150 + per;
      wmark.appendChild(el("line", { x1: x1, y1: 14, x2: x1, y2: 96, class: "w-axis", "stroke-dasharray": "2 3" }));
      wmark.appendChild(el("line", { x1: x2, y1: 14, x2: x2, y2: 96, class: "w-axis", "stroke-dasharray": "2 3" }));
      wmark.appendChild(el("line", { x1: x1, y1: 118, x2: x2, y2: 118, class: "w-axis" }));
      wmark.appendChild(el("path", { d: "M" + (x1 + 6) + " 114 L" + x1 + " 118 L" + (x1 + 6) + " 122", fill: "none", class: "w-axis" }));
      wmark.appendChild(el("path", { d: "M" + (x2 - 6) + " 114 L" + x2 + " 118 L" + (x2 - 6) + " 122", fill: "none", class: "w-axis" }));
      var t = el("text", { x: x2 + 10, y: 122, class: "lab" });
      t.textContent = m.mixv
        ? (parts.length < m.mixv.length
            ? lt("lm_one_part_nopk", "EGY HULLAMHOSSZ (A KEVERT MOD EGYIK OSSZETEVOJE; EGY OSSZETEVORE NEM IRUNK CSUCSOT)")
            : lt("lm_one_part", "EGY HULLAMHOSSZ (A KEVERT MOD EGYIK OSSZETEVOJE)"))
        : lt("lm_one", "EGY HULLAMHOSSZ");
      wmark.appendChild(t);
    }

    box.textContent = "";
    MODES.forEach(function (m, idx) {
      var b = document.createElement("button");
      b.type = "button";
      b.setAttribute("aria-pressed", "false");
      /* 2026-08-26, Marci: a vizsgalt hullamhosszu modok (voros, lila) kiemelve minden valasztoban */
      /* a cimke a blokk `studied` szovege: lila "vizsgalt hullamhossz", voros "vizsgalt savban" (nem egy binaris jel) */
      b.innerHTML = '<span class="sw" style="background:' + m.css + '"></span>' + m.name +
        (m.studied ? '<i class="st">' + m.studied + '</i>' : '');
      if (m.studied) { b.classList.add("is-studied"); b.title = m.name + " · " + m.studied; }
      b.addEventListener("click", function () { set(idx); });
      box.appendChild(b);
    });
    box.addEventListener("keydown", function (e) {
      var d = (e.key === "ArrowRight" || e.key === "ArrowDown") ? 1 : ((e.key === "ArrowLeft" || e.key === "ArrowUp") ? -1 : 0);
      if (!d) return;
      e.preventDefault();
      var next = (cur + d + MODES.length) % MODES.length;
      set(next);
      box.children[next].focus();
    });

    /* 2026-08-26, Marci: a hero "7 fenymod" tenye alatt a het szin kockaban, es ugyanazt a set()-et
       hivja, tehat a lap akcent-szine onnan is valt. A kockak a lap BARMELY [data-lm-swatches] sorabba
       epulnek (a hero a valaszto ELOTT all a DOM-ban, de a script defer, tehat mindketto megvan). */
    var sws = document.querySelectorAll("[data-lm-swatches]");
    sws.forEach(function (row) {
      row.textContent = "";
      MODES.forEach(function (m, idx) {
        var b = document.createElement("button");
        b.type = "button";
        b.setAttribute("aria-pressed", "false");
        b.setAttribute("aria-label", m.name + (m.studied ? " (" + m.studied + ")" : ""));
        b.title = m.name + (m.studied ? " · " + m.studied : "");
        b.style.setProperty("--c", m.css);
        if (m.studied) b.classList.add("is-studied");
        b.addEventListener("click", function () { set(idx); });
        row.appendChild(b);
      });
    });

    var cur = -1;
    function set(idx) {
      if (idx === cur) return;
      cur = idx;
      var m = MODES[idx];
      sws.forEach(function (row) {
        for (var q = 0; q < row.children.length; q++) row.children[q].setAttribute("aria-pressed", q === idx ? "true" : "false");
      });
      /* az akcent-szin a `.lm` elemeken ul (nem a :root-on), ezert mindegyiken allitjuk */
      document.querySelectorAll(".lm").forEach(function (n) { n.style.setProperty("--accent", m.css); });
      for (var i = 0; i < stageImgs.length; i++) stageImgs[i].classList.toggle("on", stageImgs[i].dataset.m === m.k);
      for (var k in marks) marks[k].setAttribute("opacity", k === m.k ? "1" : "0");
      roName.textContent = m.name;
      roNm.innerHTML = m.nmv !== null
        ? m.nmv + '<small>NM</small>'
        : (m.bandv ? m.bandv[0] + "–" + m.bandv[1] + '<small>NM ' + lt("lm_band", "SAV") + '</small>' : (m.mixv ? lt("lm_mixed", "KEVERT") : lt("lm_no_num", "NEM ÍRUNK SZÁMOT")));
      roNote.textContent = m.note || "";
      /* a hullamhosszhoz tartozo kutatas; ahol nincs, a lenyilo el is tunik */
      if (roEv) roEv.innerHTML = m.ev || "";
      /* 2026-08-26 este: a "miert pont ez" es a "mit vizsgaltak" EGY lenyiloban (Marci: szinenkent egy nyitas) */
      if (roEvWrap) { roEvWrap.hidden = !(m.ev || m.why); roEvWrap.open = false; }
      if (whyEl) whyEl.innerHTML = m.why || "";
      if (whyName) whyName.textContent = m.name;
      if (whyNm) whyNm.innerHTML = roNm.innerHTML;
      drawWave(m);
      for (var j = 0; j < box.children.length; j++) box.children[j].setAttribute("aria-pressed", j === idx ? "true" : "false");
    }
    set(0);
  }

  /* v17c: a lelegzes FAZISA indexbol (het sav), hogy ket szomszed sose egy utemben villanjon.
     CSS nth-of-type-pal nem megy: az a span-testverek kozt szamol, egy bekezdesben 1-2 szines
     szo van, tehat majdnem mind az elso lenne. A CTA 3 uteme CSAK belepeskor (.is-in). */
  function phase(s) {
    var i = 0;
    s.querySelectorAll(".lm-nm, .lm-ico, .lm-dot, .lm-modes .sw, .lm-eight .icons i, .lm-wear__tag i, .lm-y, .lm-n, .lm-endp .y, .lm-endp .n")
      .forEach(function (n) { n.style.animationDelay = (-(i++ % 7) * 0.63).toFixed(2) + "s"; });
    if (!("IntersectionObserver" in window)) return;
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add("is-in"); io.unobserve(e.target); } });
    }, { threshold: .6 });
    s.querySelectorAll(".lm-btn, .lm-cta").forEach(function (b) { io.observe(b); });
  }

  /* ------------------------------------------------------------------ *
   * 3. PARBAJ-TABLA (03 szilikon vs vaz), v18g, 2026-08-26, Marci
   *
   * A Liquid a VEGALLAPOTOT irja ki (pontszamok, nyertes-cimke), tehat JS
   * nelkul es reduced-motion mellett is helyes. Itt csak annyi tortenik, hogy
   * nullarol indulunk, es minden +1 / -1 sor akkor szamolodik hozza a maga
   * oldalahoz, amikor a kepernyore er (IntersectionObserver, egyszer soronkent).
   * A sticky tabla teteje a lathato sticky fejlec ala kerul (mint az onface-nel).
   * ------------------------------------------------------------------ */
  function duel(wrap) {
    var board = wrap.querySelector(".lm-duel");
    var rows = wrap.querySelectorAll("[data-lm-round]");
    if (!board || !rows.length) return;

    /* Kimerve (2026-08-26): a tema fejlece lefele gorgetve ELREJTOZIK (a sticky wrapper alja 0-ra
       csuszik), es csak a 44 px-es tartalomjegyzek marad fent. Betolteskor merve 281/200 px jott ki,
       es a tabla a szekcio kozepen ragadt. Ezert: csak az EPPEN a viewport tetejen ulo sticky/fixed
       elemek szamitanak (teteje <= 0, alja > 0), es gorgetesre ujra merunk (rAF-fal ritkitva). */
    var raf = 0;
    function place() {
      raf = 0;
      var px = 0;
      var el = document.querySelectorAll(".shopify-section-group-header-group, sticky-header, .header-wrapper, [data-dstoc]");
      for (var k = 0; k < el.length; k++) {
        if (el[k].hasAttribute && el[k].hasAttribute("hidden")) continue;
        var cs = getComputedStyle(el[k]);
        if (cs.position !== "sticky" && cs.position !== "fixed") continue;
        var r = el[k].getBoundingClientRect();
        if (r.top > 1 || r.bottom <= 0) continue;
        if (r.bottom > px) px = r.bottom;
      }
      wrap.style.setProperty("--lm-duel-top", Math.round(px) + "px");
    }
    function ask() { if (!raf) raf = requestAnimationFrame(place); }
    addEventListener("resize", ask, { passive: true });
    /* 2026-10-18: a tema fejlece gorgetes UTAN usztatva jon elo, a scroll-kori meres meg a regi helyzetet latja, es a
       fejlec a szinpad tetejere ult. Ezert a gorgetes leallta utan meg egyszer merunk. */
    var settle = 0;
    addEventListener("scroll", function () { ask(); clearTimeout(settle); settle = setTimeout(ask, 380); }, { passive: true });
    setTimeout(place, 400);
    place();

    /* v18h (Marci): SZINPAD. A szempontok egymasra fektetve, gorgetesre EGY aktiv (a wrapper magas, a szinpad
       ragad; a lepes-index a gorgetesi helyzetbol, tehat visszafele is helyes). A score az aktiv indexig
       szamolt +1/-1, minden valtasnal bump + repulo "+1"/"-1" + glow. Nyilak: sima gorgetes a lepeshez. */
    var stage = wrap.querySelector("[data-lm-stage]");
    var nav = wrap.querySelector("[data-lm-nav]");
    if (!stage || !nav) return;
    if (matchMedia("(prefers-reduced-motion: reduce)").matches) return;

    var scoreA = wrap.querySelectorAll('[data-lm-score="a"]');
    var scoreB = wrap.querySelectorAll('[data-lm-score="b"]');
    var flyA = wrap.querySelector('[data-lm-fly="a"]'), flyB = wrap.querySelector('[data-lm-fly="b"]');
    var pos = nav.querySelector("[data-lm-pos]"), dots = nav.querySelector("[data-lm-dots]");
    var prev = nav.querySelector("[data-lm-prev]"), next = nav.querySelector("[data-lm-next]");
    var N = rows.length, cur = -1, step = 400, stageH = 600;

    dots.textContent = "";
    rows.forEach(function (r) {
      var d = document.createElement("i");
      if (r.getAttribute("data-lm-round") === "-1") d.className = "is-n";
      dots.appendChild(d);
    });
    wrap.classList.add("is-stage");
    nav.hidden = false;

    function layout() {
      var top = parseFloat(wrap.style.getPropertyValue("--lm-duel-top")) || 0;
      /* 2026-10-18 (Marci: "tul szet van huzva, felette-alatta tul sok hely"): a szinpad nem viewport-magas,
         hanem akkora, amekkora a tartalom (fejlec + max(tabla, a legmagasabb szempont + nav)), legfeljebb a viewport. */
      var hd = stage.querySelector(".lm-duel__hd"), lg = stage.querySelector(".lm-cmplg");
      var rowH = 0;
      rows.forEach(function (r) { rowH = Math.max(rowH, r.scrollHeight); });
      var hdH = hd ? hd.offsetHeight + 16 : 0, navH = nav.offsetHeight + 18, lgH = lg ? lg.offsetHeight : 0;
      var need = innerWidth > 900
        ? hdH + Math.max(board.offsetHeight + 24, rowH + lgH + navH) + 24
        : hdH + board.offsetHeight + 12 + rowH + navH + 16;
      stageH = Math.max(380, Math.min(innerHeight - top, need));
      step = Math.max(240, Math.round(stageH * 0.45));
      stage.style.setProperty("--lm-stage-h", stageH + "px");
      wrap.style.height = (stageH + (N - 1) * step) + "px";
    }
    function bump(nodes, v, fly) {
      nodes.forEach(function (n) {
        n.textContent = v;
        n.classList.remove("is-bump"); void n.offsetWidth; n.classList.add("is-bump");
        n.classList.add("is-glow"); setTimeout(function () { n.classList.remove("is-glow"); }, 650);
      });
      if (fly) { fly.classList.remove("is-go"); void fly.offsetWidth; fly.classList.add("is-go"); }
    }
    function set(idx, first) {
      if (idx === cur) return;
      var a = 0, b = 0;
      for (var i = 0; i <= idx; i++) {
        var v = rows[i].getAttribute("data-lm-round");
        if (v === "-1") a++; else if (v === "+1") b++;
      }
      var was = rows[cur] ? rows[cur].getAttribute("data-lm-round") : null;
      var forward = idx > cur;
      cur = idx;
      rows.forEach(function (r, i) {
        r.classList.toggle("is-active", i === idx);
        r.classList.toggle("is-past", i < idx);
      });
      var nowV = rows[idx].getAttribute("data-lm-round");
      var aTxt = String(a), bTxt = String(b);
      if (first) { scoreA.forEach(function (n) { n.textContent = aTxt; }); scoreB.forEach(function (n) { n.textContent = bTxt; }); }
      else if (forward) { if (nowV === "-1") bump(scoreA, aTxt, flyA); else if (nowV === "+1") bump(scoreB, bTxt, flyB); else { scoreA.forEach(function (n) { n.textContent = aTxt; }); scoreB.forEach(function (n) { n.textContent = bTxt; }); } }
      else { if (was === "-1") bump(scoreA, aTxt, null); else if (was === "+1") bump(scoreB, bTxt, null); }
      var done = idx === N - 1;
      board.classList.toggle("is-done", done);
      board.classList.toggle("is-win-b", done && b > a);
      board.classList.toggle("is-win-a", done && a > b);
      pos.textContent = (idx + 1) + " / " + N;
      for (var k = 0; k < dots.children.length; k++) dots.children[k].classList.toggle("is-on", k === idx);
      prev.disabled = idx === 0; next.disabled = done;
    }
    var raf2 = 0;
    function onScroll() {
      raf2 = 0;
      var top = parseFloat(wrap.style.getPropertyValue("--lm-duel-top")) || 0;
      var rel = top - wrap.getBoundingClientRect().top;      /* mennyit gorgettunk a wrapper tetejetol */
      var idx = Math.round(rel / step);
      if (idx < 0) idx = 0; if (idx > N - 1) idx = N - 1;
      set(idx, cur < 0);
    }
    function askScroll() { if (!raf2) raf2 = requestAnimationFrame(onScroll); }
    function go(i) {
      if (i < 0 || i > N - 1) return;
      var top = parseFloat(wrap.style.getPropertyValue("--lm-duel-top")) || 0;
      var y = scrollY + wrap.getBoundingClientRect().top - top + i * step + 2;
      scrollTo({ top: y, behavior: "smooth" });
    }
    prev.addEventListener("click", function () { go(cur - 1); });
    next.addEventListener("click", function () { go(cur + 1); });
    addEventListener("scroll", askScroll, { passive: true });
    /* 2026-10-05: a mobil cimsav ki/be csak a MAGASSAGOT valtoztatja; arra a 3600 px-es wrapper
       ujraszamolasa 300-400 px-et rantott az oldalon. Csak szelesseg-valtozasra (orientacio is az). */
    var lastW = innerWidth;
    addEventListener("resize", function () { if (innerWidth !== lastW) { lastW = innerWidth; layout(); } askScroll(); }, { passive: true });
    layout(); setTimeout(function () { layout(); onScroll(); }, 450);
    /* 2026-10-18: a szinpad magassaga a tartalomtol fugg, ezert a kepek betoltese utan ujramerunk */
    addEventListener("load", function () { layout(); onScroll(); });
    board.querySelectorAll("img").forEach(function (im) { if (!im.complete) im.addEventListener("load", function () { layout(); onScroll(); }); });
    onScroll();
  }

  function boot(scope) {
    var s = scope || document;
    s.querySelectorAll("[data-lm-pick]").forEach(function (p) { init(p.closest("section") || p.parentNode); });
    s.querySelectorAll("[data-lm-duel]").forEach(duel);
    (s === document ? document.querySelectorAll(".lm") : s.querySelectorAll(".lm")).forEach(colorize);
    phase(s);
  }

  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", function () { boot(); });
  else boot();
  document.addEventListener("shopify:section:load", function (e) { boot(e.target); });
})();
